import React, {useEffect, useState} from 'react';
import Code from '../Code';
import styles from './BlogCodeWithLink.module.css';

const BlogCodeWithLink = ({className = '', link, children, src = '', language, ...props}) => {
  const [codeContent, setCodeContent] = useState('');

  useEffect(() => {
    if (src) {
      const fetchData = async () => {
        const response = await fetch(src);
        const content = await response.text();
        setCodeContent(content);
      };
      fetchData();
    }
  }, [src]);

  return (
    <div className="relative flex flex-col items-center">
      <div className={styles.nextContainer}>
        <Code className={`${className} ${styles.code} `} language={language} {...props}>
          {!src ? children : codeContent}
        </Code>
        <span className="items-center text-sm italic">
          <a href={link}>{link}</a>
        </span>
      </div>
    </div>
  );
};

export default BlogCodeWithLink;
